import cn from 'classnames';
import React from 'react';
import ShefDishShowcaseChips from 'src/pages/consumer/meal-plans/components/ShefDishShowcaseChips';
import { DynamicImage } from 'src/shared/design-system/DynamicImage';

interface MealPlanShefCardProps {
  shefId: string;
  shefName: string;
  shefImageUrl: string;
  cuisines: string[];
  rating: number;
  ratingCount: number;
  backgroundImageUrl: string;
  totalOrders: number;
  className?: string;
  onClick?: (shefId: string) => void;
}

export const MealPlanShefCard: React.FC<MealPlanShefCardProps> = ({
  shefId,
  shefName,
  shefImageUrl,
  cuisines,
  rating,
  ratingCount,
  backgroundImageUrl,
  totalOrders,
  className,
  onClick,
}) => {
  const handleClick = () => {
    onClick?.(shefId);
  };

  // Format cuisines as a string with bullet separator
  const cuisineText = cuisines.join(' • ');

  return (
    <div
      onClick={handleClick}
      className={cn(
        'flex flex-col overflow-hidden rounded-md border border-neutral-100 bg-white shadow-lg',
        'mb-4 h-[260px] w-[240px] shrink-0 grow-0',
        className,
        { 'cursor-pointer': !!onClick }
      )}>
      <section className='relative h-40 w-full'>
        {/* Background dish image */}
        <DynamicImage sourceHeight={160} sourceWidth={240} width={240} height={160} src={backgroundImageUrl} alt='' />

        {/* Shef profile image - positioned in bottom right */}
        <DynamicImage
          sourceHeight={64}
          sourceWidth={64}
          height={64}
          width={64}
          src={shefImageUrl}
          alt={`Shef ${shefName}`}
          className='absolute -bottom-6 right-0 rounded-full border-4 border-solid border-white'
        />
      </section>

      {/* Card content */}
      <div className='flex w-full flex-1 flex-col justify-between p-4 pt-3'>
        <div className='flex flex-col items-start justify-between gap-1'>
          <div className='flex items-baseline'>
            <span className='text-body-600 text-eggplant'>Shef</span>
            <span className='ml-2 font-quick-writers text-h4 text-raspberry'>{shefName}</span>
          </div>

          {/* Cuisines */}
          <p className='m-0 line-clamp-1 text-caption-600 text-eggplant-500'>{cuisineText}</p>

          {/* Rating */}
          <ShefDishShowcaseChips
            shefId={shefId}
            shefRatingScore={rating}
            shefRatingCount={ratingCount}
            shefTotalOrders={totalOrders}
            hideRatingCountChip
          />
        </div>
      </div>
    </div>
  );
};
